"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImageUrl = buildImageUrl;
function buildImageUrl(rawUrl, params) {
    // Console preview templates pass Mustache tokens (e.g. "{{ctImage}}") in place
    // of image URLs. These are not valid URLs, so pass them through untouched
    // instead of throwing. Real image URLs never contain "{{".
    if (rawUrl.includes("{{"))
        return rawUrl;
    const url = new URL(rawUrl.trim());
    url.search = "";
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    return url.toString();
}
